const skillsData = [
  { id: 1, name: "JavaScript", level: 90 },
  { id: 2, name: "React", level: 85 },
  { id: 3, name: "Node.js", level: 80 },
  { id: 4, name: "HTML/CSS", level: 95 },
  { id: 5, name: "Git", level: 85 }
];

export default skillsData;